import { VendorStatus } from '@sib/api';

const vendorStatusColorToken: Record<VendorStatus, string> = {
  [VendorStatus.Active]: 'hsl(var(--success-subtle))',
  [VendorStatus.Inactive]: 'hsl(var(--info-soft))',
  [VendorStatus.OnHold]: 'hsl(var(--warning-subtle-alt))',
};

export const getVendorStatusColor = (
  status: VendorStatus = VendorStatus.Active
) =>
  vendorStatusColorToken[status] ?? vendorStatusColorToken[VendorStatus.Active];
